<div class="vl-app-light:bg-[#F0F0F0] orb-app-light:bg-[#F0F0F0] h-full md:p-8">
    <div
        class="sr-app-light:visible vl-app-light:visible border-b border-solid border-opacity-10 bg-[var(--color-panel)] py-2 dark:border-contrast-yellow md:invisible">
        <div class="flex flex-row items-center justify-between">
            <ion-button
                [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
                [routerLink]="'/account/messages' | localize"
                [queryParams]="{ fromMessageDetailView: true, id: currentMessage?.id }"
                [skipLocationChange]="true"
                fill="clear">
                <ion-icon
                    class="mr-1 text-xl dark:filter-yellow"
                    src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg">
                </ion-icon>
            </ion-button>
            <h1 class="orb-app-light-dark:font-semibold text-base font-bold leading-5">
                {{ 'MESSAGE_DETAILS' | translate }}
            </h1>
            <div class="w-14"></div>
        </div>
    </div>
    <div class="block--wrap mt-4 block bg-white" *ngIf="currentMessage">
        <div class="messages-list p-4">
            <div class="text-base font-bold leading-7">{{ currentMessage.subject }}</div>
            <div class="menu-divider mb-2 mt-2 h-px bg-[#0000001a]"></div>
            <div class="orb-app-light:text-base orb-app-light:text-grey-dark pb-1 text-xs">
                {{ 'PUBLISHED' | translate }}&nbsp;
                {{ currentMessage.sendAt | formatTimeZone: DATE_TIME_FORMAT : TIMEZONE }}
            </div>
            <div class="text-base">{{ currentMessage.body }}</div>
            <div class="menu-divider mb-2 mt-2 h-px bg-[#0000001a]"></div>
            <div class="flex-column flex gap-4">
                <ion-button class="m-0 w-full" (click)="markAsReadUnread()" size="small" fill="clear">
                    <ion-icon
                        class="text-[1.5rem] text-secondary dark:text-contrast-yellow"
                        aria-hidden="true"
                        src="{{ assetsPath$ | async }}/img/menu/reset.svg"></ion-icon>
                    <ion-label
                        class="orb-app-light-dark:font-semibold p-1.5 text-base font-bold normal-case text-secondary dark:text-contrast-yellow">
                        {{ (messageRead ? 'MARK_AS_UNREAD' : 'MARK_AS_READ') | translate }}
                    </ion-label>
                </ion-button>
                <ion-button
                    class="m-0 w-full"
                    *ngIf="currentMessage?.redirectUrl"
                    [href]="currentMessage.redirectUrl"
                    role="button"
                    target="_blank"
                    rel="noopener"
                    size="small"
                    fill="clear">
                    <ion-label class="p-1.5 text-base font-bold normal-case text-secondary dark:text-contrast-yellow">
                        <div class="flex items-center gap-2">
                            {{ 'READ_MORE' | translate }}
                            <ion-icon
                                class="text-[1.5rem] text-secondary dark:text-contrast-yellow"
                                name="open-outline"
                                aria-hidden="true"></ion-icon>
                        </div>
                    </ion-label>
                </ion-button>
            </div>
        </div>
    </div>
</div>
